import React from 'react';
import SfiLoader from 'components/Additional/SfiLoader/SfiLoader';

import styles from './DidYouKnow.module.css';

const DidYouKnow = ({ title }) => {
	return (
		<div className={styles.internal_loader}>
			<SfiLoader />
			{title && (
				<div className={styles.loader_title}>
					<span>Calculating your estimate</span>
				</div>
			)}
			<div className={styles.loader_text_wrapper}>
				<p className={styles.loader_text1}>Did you know?</p>
				<p className={styles.loader_text2}>
					The MarketWatch Guides Home Team
					<br />
					has named Security First Insurance the
					<br />
					Best Pick for Hurricane Protection in
					<br />
					Florida for 2022, 2023, 2024, and 2025.
					<br />
					<br />
					When it matters the most, we are here for
					<br />
					you storm after storm, year after year.®
				</p>
			</div>
		</div>
	);
};

export default DidYouKnow;
